<section class="w-full h-full">
    <section>
        <h1 class="text-2xl text-text font-display font-bold">Welcome to Funpay powered by Adyen</h1>
    </section>

    <section class="w-full p-4 grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3" (animate.enter)="enterCards($event)">
        @let checkedClients = availableClients();
        <!-- An empty array is still truthy, so the skeletons need a length check to ever show. -->
        @if (checkedClients.length) { @for (client of checkedClients; track client.id) {
        <venue-card [venue]="client" />
        } } @else { @for (placeholder of [1, 2, 3, 4, 5, 6]; track placeholder) {
        <p-skeleton width="100%" height="300px" />
        } }
    </section>
</section>
